import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import "../../assets/FollowupS2/css/custom.scss";
import "../../assets/FollowupS2/css/id_upload.scss";
import "../../assets/FollowupS2/css/openbank.scss";
import "../../assets/FollowupS2/css/signature.scss";
import "../../assets/FollowupS2/css/style.scss";
import { queryString } from "../../Utility/QueryString";
import { useOpenBanking } from "../../Hooks/useOpenBanking";
import { Api } from "../../api/Api";

const CreditCheckS2 = () => {
  const [loader, setLoader] = useState(1);
  const [credLoader, setCredLoader] = useState(0);
  const [proceedLoader, sePproceedLoader] = useState(0);
  const [iframeUrl, setIframeUrl] = useState(null);
  const [btndisable, setBtnDisable] = useState(false);

  const urlPortion = localStorage.getItem("url_portion");
  const fname = localStorage.getItem("fName");
  const UcFname = localStorage.getItem("UcFname");
  //const credcheckStat = localStorage.getItem("credStat");
  const history = useHistory();
  const { OpenBankVisit, storeClickResponse } = useOpenBanking();
  const query = new URLSearchParams(window.location.search);
  const query_uuid = query.get("uuid");
  const local_storage_uuid = localStorage.getItem("uuid");
  var uuid = query_uuid ? query_uuid : local_storage_uuid;
  const query_source = query.get("atp_sub6");
  var source = localStorage.getItem("source");
  const user_data = { uuid: uuid, source: source };
  let btn_label = "";
  let page = "";

  useEffect(() => {
    (async () => {
      if (uuid) {
        const response = await Api.get(
          "/api/v1/user-basic-details-s2?uuid=" + uuid,
          {}
        );
        if (response.data.status === "Success") {

          let complete = response.data.response.completed;

          if(complete == 1){
            history.push("/thankyou?uuid=" + uuid);
          }

          
          let payload = { page: "CREDIT_CHECK", type: "visit", source };
          await storeClickResponse(
            { uuid: uuid },
            "ob_creditcheck_history",
            uuid,
            payload
          );

          setTimeout(() => {
            setLoader(0);
          }, 1500);

          let title = response.data.response.lstSalutation;
          let fname = response.data.response.txtFName;
          let lname = response.data.response.txtLName;
          let email = response.data.response.txtEmail;
          let phone = response.data.response.txtPhone;
          let dob = response.data.response.dob;
          let straddr = response.data.response.txtAddressline2;
          let city = response.data.response.town;
          let zip = response.data.response.txtPostcode;
          let clientRefId = response.data.response.uuid;

          let urlPortion =
            "title=" +
            title +
            "&fname=" +
            fname +
            "&lname=" +
            lname +
            "&email=" +
            email +
            "&phone=" +
            phone +
            "&dob=" +
            dob +
            "&abodenumber=" +
            "&straddr=" +
            straddr +
            "&street=" +
            "&city=" +
            city +
            "&zip=" +
            zip +
            "&clientRefId=" +
            clientRefId;

          let iframUrl =
            "https://uk.rspcdn.com/xprr/red/PID/3916?" + urlPortion;
          console.log(iframUrl);
          setIframeUrl(iframUrl);
        }
      } else {
        history.push("/thankyou");
      }
    })();
  }, []);

  const redirectCreditCheck = async (e) => {
    setBtnDisable(true);
    setLoader(1);
    //setCredLoader(1);

    btn_label = e.target.getAttribute("data-btn-label");
    page = e.target.getAttribute("data-page-label");

    let payload = {
      page,
      type: "btn_click",
      btn_label,
      source,
      click_btn: "3",
    };
    await storeClickResponse(
      { uuid: uuid },
      "ob_creditcheck_history",
      uuid,
      payload
    );

    const flpResponse = await OpenBankVisit(
      "creditcheck_stats",
      uuid,
      user_data,
      "proceed-creditcheck",
      queryString,
      "v1"
    );
    setTimeout(() => {
      setLoader(0);
      setCredLoader(1);
    }, 1500);
  };

  return (
    <>
      <div className="followups2newFlow">
        <div className="tms-wrap2 bg-main-pr">
          <div
            className={`text-center loader-wrap ${
              loader == 1 ? "showload" : "hide"
            }`}
          >
              <div className="loader-logo">
                <img
                  src="assets/img/a00187b31dd5a4ece0c8f809b69962eb.png"
                  alt=""
                />
              </div>
            <div className="loader">
              <img src="assets/img/review.gif" alt="" />
              <p>Analysing your informations</p>
            </div>
          </div>
          <div className={`${credLoader == 0 ? "showload" : "hide"}`}>
            <div
              className={`main text-center main-div  ${
                loader == 0 ? "showload" : "hide"
              }`}
            >
              <div className="brand-logo mt-lg-0 mt-md-2 mt-sm-2 mt-2">
                <img
                  height="65"
                  src="assets/img/a00187b31dd5a4ece0c8f809b69962eb.png"
                  alt=""
                />
              </div>
              <div className="container">
                <div className="item-cent-flx ">
                  <div className="pt-lg-5 pt-md-3 pt-sm-3  pt-3 text-center">
                    <div className="openbank-slide3  ">
                      <div className="  text-center">
                        <div className="col-lg-8 offset-lg-2 px-4 mb-2 text-center">
                          <h1 className="  mt-md-2 mt-sm-2 mt-0 text-danger">
                            {" "}
                            <span className="text-capitalize">{fname}</span>, We require your credit report to complete
                            our comprehensive investigation and finalise your
                            complaint{" "}
                          </h1>
                          <p style={{ maxWidth: "800px " }} className="my-3 ">
                            We have partnered with UK Credit Ratings to offer a
                            FREE, comprehensive, and simple - to -use service.{" "}
                          </p>
                        </div>
                        <div className="row   mt-md-2 mt-sm-3 mt-0">
                          <div className="col-lg-6 offset-lg-3 px-4 mb-2 text-center">
                            <div>
                              <button
                                onClick={redirectCreditCheck}
                                disabled={btndisable}
                                data-btn-label="access_free_credit_report"
                                data-page-label="CREDIT_CHECK"
                                className="  btn-comm2 mt-lg-3 mt-md-3 mt-sm-3 mt-0 second anim_green disablebtn"
                              >
                                {" "}
                                Access Free Credit Report <span> ›</span>{" "}
                              </button>
                              {/* <button id="final" className="  btn-comm2 second">
                          Access Free Credit Report <span> <i className="bi bi-arrow-right-short"></i></span> </button> */}
                              <p className="mt-3 text2b mb-2">
                                {" "}
                                24/7 Monitoring, Individual Credit Review.
                                Correct Credit Errors.
                              </p>
                              <p className="mt-0 text3b text-danger">
                                <i className="fa fa-clock-o"> </i> Estimated
                                Processing 1 minutes
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="text-center mt-4">
                          <img src="assets/img/uk-credits.png" alt="" />
                        </div>
                      </div>
                    </div>
                    <div className="mb-lg-5 mb-md-5 mb-sm-3 mb-3 mt-5 mt-lg-3 mt-md-5 mt-sm-5 ">
                      <img
                        height="30"
                        src="assets/img/LGO_UKC_Black.svg"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="lg-5">
                <img
                  height="50"
                  className="safe-secure-img"
                  src="assets/img/safe and secure.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>

        <div
          className={`${
            credLoader == 1 ? "showload" : "hide"
          } iframe-container`}
        >
          <iframe src={iframeUrl} frameborder="0"></iframe>
        </div>
      </div>
    </>
  );
};
export default CreditCheckS2;
